var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarPaymentpage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3847 18.9655C15.7872 18.9655 16.9231 17.8082 16.9231 16.3793C16.9231 14.9504 15.7872 13.7931 14.3847 13.7931C12.9822 13.7931 11.8462 14.9504 11.8462 16.3793C11.8462 17.8082 12.9822 18.9655 14.3847 18.9655Z",
    fill: "#717075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66667 0C1.64144 0 0 1.86528 0 4.16667V20.8333C0 23.1347 1.64144 25 3.66667 25H18.3333C20.3586 25 22 23.1347 22 20.8333V4.16667C22 1.86528 20.3586 0 18.3333 0H3.66667ZM2.44444 20.8333V6.94444H19.5556V20.8333C19.5556 21.6 19.008 22.2222 18.3333 22.2222H3.66667C2.992 22.2222 2.44444 21.6 2.44444 20.8333Z",
    fill: "#717075"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPaymentpage);
export default __webpack_public_path__ + "static/media/calendar-paymentpage.906563045a90f8b7bc47bc41f0b252cc.svg";
export { ForwardRef as ReactComponent };